"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityFollowControls = exports.EntityFollowControlsDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_follow_button_1 = require("./entity-follow-button");
var followers_badge_1 = require("./followers-badge");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_lang_1 = require("../../hooks/use-lang");
var badge_1 = require("../elements/badge");
var lodash_1 = require("lodash");
var client_1 = require("@apollo/client");
var use_followable_entities_1 = require("../../hooks/use-followable-entities");
var graphql_1 = require("../../utils/graphql");
var sprintf_js_1 = require("sprintf-js");
var use_entity_following_state_1 = require("../../hooks/use-entity-following-state");
exports.EntityFollowControlsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    min-height: 20px;\n    flex-direction: row;\n    align-items: center;\n    \n  "], ["\n    display: flex;\n    min-height: 20px;\n    flex-direction: row;\n    align-items: center;\n    \n  "])))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var UnfollowButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n\n    display: none;\n  "], ["\n    ", ";\n\n    display: none;\n  "])), ButtonStyles)
});
var FollowersStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    height: 18px;\n    overflow: visible;\n\n    ", "\n  "], ["\n    height: 18px;\n    overflow: visible;\n\n    ", "\n  "])), function (props) {
    return props.showBorder && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "], ["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "])), theme_1.theme.UNIT(4, 2), theme_1.theme.UNIT(4), theme_1.theme.V_DOT_BG_END());
  })
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 16px;\n    line-height: 16px;\n  "], ["\n    height: 16px;\n    line-height: 16px;\n  "])))
});
var FollowersCountStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    white-space: nowrap;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n\n    ", "\n\n  "], ["\n    white-space: nowrap;\n    margin: 0;\n    padding: 0;\n    font-weight: 400;\n\n    ", "\n\n  "])), function (props) {
    return props.showBorder && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "], ["\n      padding-right: ", ";\n      margin-right: ", ";\n      ", ";\n    "])), theme_1.theme.UNIT(4, 2), theme_1.theme.UNIT(4), theme_1.theme.V_DOT_BG_END());
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""]))),
  Button: (0, styled_components_1.default)(entity_follow_button_1.EntityFollowButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  UnfollowButton: (0, styled_components_1.default)(entity_follow_button_1.EntityFollowButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), UnfollowButtonStyles),
  FollowersCount: styled_components_1.default.h5(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), FollowersCountStyles),
  Followers: (0, styled_components_1.default)(followers_badge_1.FollowersBadge)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), FollowersStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
My.Container = styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  ", " {\n    &:hover {\n      ", "\n\n    }\n  }\n"], ["\n  ", " {\n    &:hover {\n      ", "\n\n    }\n  }\n"])), ContainerStyles, function (props) {
  return props.canFollow && props.isFollowing && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n        ", " {\n          display: none;\n        }\n        ", " {\n          display: flex;\n        }\n      "], ["\n        ", " {\n          display: none;\n        }\n        ", " {\n          display: flex;\n        }\n      "])), My.Badge, My.UnfollowButton);
});
var EntityFollowControls = function (props) {
  var className = props.className,
    entity = props.entity;
  var user = (0, use_active_person_1.useActivePerson)();
  var person = user.person;
  var t = (0, use_lang_1.useLang)();
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var client = (0, client_1.useApolloClient)();
  var followableEntities = (0, use_followable_entities_1.useFollowableEntities)();
  var FOLLOW_MUTATION = (0, react_1.useMemo)(function () {
    return (0, graphql_1.gql)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      mutation followMutation($entityTypeName: String!, $id: String!) {\n        follow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n          conversationChannels {\n            id\n            channelRole\n            entity { ...EntityValueFields }\n          }\n          ", "\n          photo {\n            id\n            url\n            width\n            height\n            aspectRatio\n          }\n        }\n      }\n    "], ["\n      mutation followMutation($entityTypeName: String!, $id: String!) {\n        follow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n          conversationChannels {\n            id\n            channelRole\n            entity { ...EntityValueFields }\n          }\n          ", "\n          photo {\n            id\n            url\n            width\n            height\n            aspectRatio\n          }\n        }\n      }\n    "])), (0, lodash_1.map)(followableEntities, function (definition) {
      return "".concat(definition.followingFieldName, " { id name slug __typename }");
    }));
  }, [followableEntities]);
  var UNFOLLOW_MUTATION = (0, react_1.useMemo)(function () {
    return (0, graphql_1.gql)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      mutation unfollowMutation($entityTypeName: String!, $id: String!) {\n        unfollow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n          conversationChannels {\n            id\n            channelRole\n            entity { ...EntityValueFields }\n          }\n          ", "\n          photo {\n            id\n            url\n            width\n            height\n            aspectRatio\n          }\n        }\n      }\n    "], ["\n      mutation unfollowMutation($entityTypeName: String!, $id: String!) {\n        unfollow(entityTypeName: $entityTypeName, id: $id) {\n          id\n          name\n          defaultPath\n          isWriteable\n          role {\n            id\n            name\n          }\n          conversationChannels {\n            id\n            channelRole\n            entity { ...EntityValueFields }\n          }\n          ", "\n          photo {\n            id\n            url\n            width\n            height\n            aspectRatio\n          }\n        }\n      }\n    "])), (0, lodash_1.map)(followableEntities, function (definition) {
      return "".concat(definition.followingFieldName, " { id name slug __typename }");
    }));
  }, [followableEntities]);
  var _a = __read((0, client_1.useMutation)(FOLLOW_MUTATION), 1),
    follow = _a[0];
  var _b = __read((0, client_1.useMutation)(UNFOLLOW_MUTATION), 1),
    unfollow = _b[0];
  // entities of this type the current user is following
  var followingFieldName = "".concat(definition.followingFieldName);
  var isCurrentlyFollowing = !!(0, lodash_1.find)(person[followingFieldName] || [], function (p) {
    return p.id === entity.id;
  });
  var isModerating = !!(0, lodash_1.find)(entity.moderators || [], function (p) {
    return p.id === person.id;
  });
  var _c = __read((0, use_entity_following_state_1.useEntityFollowingState)(definition.name, entity.id, {
      isFollowing: isCurrentlyFollowing,
      count: entity.followersCount
    }), 2),
    followingState = _c[0],
    setFollowingState = _c[1];
  var count = followingState.count,
    isFollowing = followingState.isFollowing;
  var followersLabel = (0, sprintf_js_1.sprintf)(count === 1 ? t('%s Follower') : count === 0 ? t("No Followers") : t('%s Followers'), count);
  // const followers = entity.followers || [];
  var onFollow = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // optimistic update
            setFollowingState({
              isFollowing: true,
              count: count + 1
            });
            // follow returns an updated person record, which will update the Apollo cache with new following info
            // await follow({ variables: { entityTypeName: definition.name, id: entity.id } });
            return [4 /*yield*/, follow({
              variables: {
                entityTypeName: definition.name,
                id: entity.id
              }
            })];
          case 1:
            // follow returns an updated person record, which will update the Apollo cache with new following info
            // await follow({ variables: { entityTypeName: definition.name, id: entity.id } });
            _a.sent();
            // for some reason, this just NEVER WORKS. Apollo is infuriating.
            // conversationChannels.refresh();
            client.cache.evict({
              id: "".concat(definition.name, ":").concat(entity.id)
            });
            return [2 /*return*/];
        }
      });
    });
  };
  var onUnfollow = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setFollowingState({
              isFollowing: false,
              count: count - 1
            });
            // follow returns an updated person record, which will update the Apollo cache with new following info
            return [4 /*yield*/, unfollow({
              variables: {
                entityTypeName: definition.name,
                id: entity.id
              }
            })];
          case 1:
            // follow returns an updated person record, which will update the Apollo cache with new following info
            _a.sent();
            // conversationChannels.refresh();
            client.cache.evict({
              id: "".concat(definition.name, ":").concat(entity.id)
            });
            return [2 /*return*/];
        }
      });
    });
  };
  // console.log(user);
  // const canFollow = personCan(user, ['read:following', 'write:following', 'write:any']);
  var isMe = person && person.id === entity.id;
  // currently we cannot show the followers of a person as Airtable cannot do a reverse field of a field in the same table.
  // we can create a derived resolver, but this is currently too expensive without a perf tweak.
  var canShowFollowers = definition.name !== 'Person';
  if (isMe && !canShowFollowers) {
    return null;
  }
  return react_1.default.createElement(My.Container, {
    canFollow: true,
    isFollowing: isFollowing,
    className: "entity-follow-controls ".concat(className)
  }, canShowFollowers && react_1.default.createElement(My.FollowersCount, {
    showBorder: !isMe
  }, followersLabel), !isMe && (isFollowing || isModerating ? react_1.default.createElement(react_1.default.Fragment, null, !isModerating && react_1.default.createElement(My.UnfollowButton, {
    isUnfollow: true,
    onClick: onUnfollow,
    entity: entity
  }), react_1.default.createElement(My.Badge, null, t(isModerating ? 'Moderating' : 'Following'))) : react_1.default.createElement(My.Button, {
    onClick: onFollow,
    entity: entity
  })));
};
exports.EntityFollowControls = EntityFollowControls;
exports.EntityFollowControls.defaultProps = exports.EntityFollowControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;